import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import ChiSiamo from './pages/ChiSiamo';
import Qualita from './pages/Qualita';
import Clienti from './pages/Clienti';
import Prodotti from './pages/Prodotti';
import Produzione from './pages/Produzione';
import Progettazione from './pages/Progettazione';
import Elpa from './pages/Elpa';
import './index.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/chi-siamo" element={<ChiSiamo />} />
          <Route path="/qualita" element={<Qualita />} />
          <Route path="/clienti" element={<Clienti />} />
          <Route path="/prodotti" element={<Prodotti />} />
          <Route path="/progettazione" element={<Progettazione />} />
          <Route path="/produzione" element={<Produzione />} />
          <Route path="/elpa" element={<Elpa />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;